//@ts-nocheck
import account from '../../assets/icons/account.svg'
import alert from '../../assets/icons/alert.svg'
import arrow from '../../assets/icons/arrow.svg'
import axes from '../../assets/icons/axes.svg'
import caretDown from '../../assets/icons/caret-down.svg'
import chart from '../../assets/icons/chart.svg'
import clock from '../../assets/icons/clock.svg'
import close from '../../assets/icons/close.svg'
import constant from '../../assets/icons/constant.svg'
import ellipsis from '../../assets/icons/ellipsis.svg'
import _export from '../../assets/icons/export.svg'
import externalLink from '../../assets/icons/external-link.svg'
import help from '../../assets/icons/help.svg'
import languages from '../../assets/icons/languages.svg'
import logout from '../../assets/icons/logout.svg'
import map from '../../assets/icons/map.svg'
import menu from '../../assets/icons/menu.svg'
import pen from '../../assets/icons/pen.svg'
import plotBands from '../../assets/icons/plot-bands.svg'
import recapLogo from '../../assets/icons/recap-logo.svg'
import report from '../../assets/icons/report.svg'
import search from '../../assets/icons/search.svg'
import watch from '../../assets/icons/watch.svg'
import waste from '../../assets/icons/waste.svg'

export const icons = {
  account,
  alert,
  axes,
  arrow,
  chart,
  chart,
  'caret-down': caretDown,
  clock,
  close,
  constant,
  'export'    : _export,
  languages,
  logout,
  map,
  menu,
  pen,
  'plot-bands': plotBands,
  report,
  'recap-logo': recapLogo,
  'recap-logo': recapLogo,
  search,
  watch,
  ellipsis,
  help,
  externalLink,
  waste
}
